<template>
    <v-sheet
        color="primary"
        elevation="8"
        rounded="sm"
        class="fuel-calculator-panel pa-3"
        @click.stop
        @mousedown.stop
        @touchstart.stop
    >
        <v-text-field
            :model-value="pricePerLiter"
            type="text"
            inputmode="decimal"
            :label="$t('formFields.fuelPrice')"
            density="compact"
            hide-details="auto"
            variant="outlined"
            color="yellow"
            base-color="yellow"
            class="fuel-calculator-panel__input mb-2"
            @update:model-value="$emit('update:pricePerLiter', $event)"
            @keydown.enter="onEnter"
        >
            <template #append-inner>
                <span class="text-caption text-yellow">RON/EUR</span>
            </template>
        </v-text-field>

        <v-text-field
            :model-value="distanceKm"
            type="text"
            inputmode="decimal"
            :label="$t('formFields.distanceKm')"
            density="compact"
            hide-details="auto"
            variant="outlined"
            color="yellow"
            base-color="yellow"
            class="fuel-calculator-panel__input mb-2"
            @update:model-value="$emit('update:distanceKm', $event)"
            @keydown.enter="onEnter"
        >
            <template #append-inner>
                <span class="text-caption text-yellow">KM</span>
            </template>
        </v-text-field>

        <v-text-field
            :model-value="consumptionLPer100Km"
            type="text"
            inputmode="decimal"
            :label="$t('formFields.fuelConsumption')"
            density="compact"
            hide-details="auto"
            variant="outlined"
            color="yellow"
            base-color="yellow"
            class="fuel-calculator-panel__input mb-2"
            @update:model-value="$emit('update:consumptionLPer100Km', $event)"
            @keydown.enter="onEnter"
        >
            <template #append-inner>
                <span class="text-caption text-yellow">L/100km</span>
            </template>
        </v-text-field>

        <div class="fuel-calculator-panel__result-row d-flex align-start">
            <span
                class="text-body-1 text-white font-weight-bold flex-shrink-0 me-2 pt-2"
            >
                {{ $t("formFields.fuelCostResult") }}:
            </span>
            <v-text-field
                :model-value="resultDisplay"
                readonly
                density="compact"
                hide-details="auto"
                variant="outlined"
                color="yellow"
                base-color="yellow"
                class="fuel-calculator-panel__input fuel-calculator-panel__result-input"
            >
                <template #append-inner>
                    <span class="text-caption text-yellow">RON/EUR</span>
                </template>
            </v-text-field>
        </div>
    </v-sheet>
</template>

<script>
import { formatFuelCostLabel } from "@/utils/fuelCostCalculation";

export default {
    name: "FuelCalculatorPanel",
    props: {
        pricePerLiter: {
            type: [String, Number],
            default: "",
        },
        distanceKm: {
            type: [String, Number],
            default: "",
        },
        consumptionLPer100Km: {
            type: [String, Number],
            default: "",
        },
    },
    emits: [
        "update:pricePerLiter",
        "update:distanceKm",
        "update:consumptionLPer100Km",
        "apply",
    ],
    computed: {
        resultDisplay() {
            return formatFuelCostLabel({
                distanceKm: this.distanceKm,
                consumptionLPer100Km: this.consumptionLPer100Km,
                pricePerLiter: this.pricePerLiter,
            });
        },
    },
    methods: {
        onEnter(event) {
            event.preventDefault();
            this.tryApply();
        },
        tryApply() {
            const resultLabel = formatFuelCostLabel({
                distanceKm: this.distanceKm,
                consumptionLPer100Km: this.consumptionLPer100Km,
                pricePerLiter: this.pricePerLiter,
            });
            if (!resultLabel) return;

            this.$emit("apply", {
                pricePerLiter: this.pricePerLiter,
                distanceKm: this.distanceKm,
                consumptionLPer100Km: this.consumptionLPer100Km,
                resultLabel,
            });
        },
    },
};
</script>

<style scoped>
.fuel-calculator-panel {
    width: 320px;
    max-width: min(320px, calc(100vw - 24px));
    border: 1px solid rgba(255, 235, 59, 0.35);
}

.fuel-calculator-panel__input {
    flex: 1 1 auto;
    min-width: 0;
}

.fuel-calculator-panel__result-row {
    margin-top: 4px;
}

.fuel-calculator-panel__result-input {
    flex: 1 1 auto;
    min-width: 0;
}
</style>
